import { allImagesOf } from '../lib/embedMedia'
import type { PostEmbedView } from '../components/PostMedia'

/**
 * Push a batch of posts' image URLs (tile thumb + fullsize + video
 * poster) to the service worker, which fetches any it doesn't already
 * hold into the cache-first image cache. Called at hydration time so
 * every post written to IndexedDB has its bytes pinned locally — the
 * image keeps loading even after the post is deleted on Bluesky.
 * Best-effort: no SW (first visit, private mode) → silently does nothing.
 */
export function warmImageCache(
  posts: Array<{ embed?: unknown; author?: { did?: string } }>,
): void {
  try {
    const ctrl = navigator.serviceWorker?.controller
    if (!ctrl) return
    const urls = new Set<string>()
    for (const p of posts) {
      if (!p?.embed) continue
      for (const m of allImagesOf(p.embed as PostEmbedView, p.author?.did)) {
        if (m.src) urls.add(m.src)
        if (m.fullsize) urls.add(m.fullsize)
      }
    }
    if (urls.size === 0) return
    ctrl.postMessage({ type: 'prefetch', urls: Array.from(urls) })
  } catch {
    // cache warming must never break hydration
  }
}
